/* unplugin-vue-components disabled */import script from "./ImgWall.vue?vue&type=script&setup=true&lang=js"
export * from "./ImgWall.vue?vue&type=script&setup=true&lang=js"

import "./ImgWall.vue?vue&type=style&index=0&id=7794c54c&lang=stylus"

const __exports__ = script;

export default __exports__